import React from 'react';
import axios from 'axios';
import Breadcrumb from  '../../../components/Layout/Breadcrumb';
import { connect } from 'react-redux';
import { Card, Col, Row, Table, Alert } from 'reactstrap';
import { MdCheck, MdWarning } from 'react-icons/md';
import { Spinner } from 'react-bootstrap';
import ListAlertAdminComponent from '../../../components/Admin/alert_admin/ListAlertAdminComponent';
import PaginateComponent from  '../../../components/PaginateComponent';
import { confirmAlert } from 'react-confirm-alert'; 
import 'react-confirm-alert/src/react-confirm-alert.css';

class AlertAdminPage extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			isLoading: true,
			error: false,
			perPage: 0,
			totalPage: 0,
			currentPage: 0,
			from: '',
            to: '',
			messageError: '',
			isNotification: '',
			textNotification: '',
			isSpinner: false,
			listAlertAdmin: [],
			checkedAlertAdminIds: [],
			rq_table: {
                per_page: 10,
                page: 0,
                s: '',
                order_by: 'id',
                order: 'desc',
            },
		}
	}

	componentDidMount() {
		window.scrollTo(0, 0);
		this.getListAlertAdmin();
		this.setState({
			isNotification: this.props.isNotification,
			textNotification: this.props.textNotification,
		})
		if ( this.props.isNotification ) {
			this.props.notification({
				isNotification: false,
				textNotification: ''
			});
		}
	}

	getListAlertAdmin = () => {
		this.setState({
			isLoading: true
		});

		let dataAuth = {
			username: process.env.REACT_APP_CLIENT_ID,
			password: process.env.REACT_APP_CLIENT_PASSWD,
			token: process.env.REACT_APP_KEY,
		};

		let config = {
		  	headers: {
				'Content-Type': 'application/json',
				'Authorization' : this.props.token,
				'dataAgency' : JSON.stringify(dataAuth)
			},
		  	params: this.state.rq_table
		}
		axios.get( process.env.REACT_APP_API_URL + '/api/admin/alert-admin/list', config)
		.then( (ref) => {
			// console.log(ref.data);
			this.setState({
				isLoading: false,
				error: false,
				messageError: '',
			});
			if ( ref.data.error === 0 ) {
				this.setState({
					listAlertAdmin: ref.data.content.data,
					rq_table: ref.data.content.filters,
					perPage: ref.data.content.perPage,
                    totalPage: ref.data.content.total,
                    currentPage: ref.data.content.current_page,
                    from: ref.data.content.from,
                    to: ref.data.content.to
				});
				this.state.listAlertAdmin.forEach( alert => {
					alert.checked = false;
		        });
			} else {
				if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
					this.props.logOut();
				} else {
					this.setState({
						error: true,
						messageError: ref.data.message,
					})
				}
			}
		})
		.catch( (error) => {
			console.log(error);
			this.setState({
				isLoading: false
			});
			this.setState({
				error: true,
				messageError: 'Lấy dữ liệu thất bại',
			})
		})
	}

	confirmAlertAdmin = (id) => {
		confirmAlert({
	      	title: '',
	      	message: `Xác nhận hoàn thành cảnh báo ID #${id}?`,
	      	buttons: [
		        {
		          	label: 'Xác nhận',
		          	onClick: () => {
		          		this.confirmAlertAdminRequest(id);
		          	}
		        },
		        {
		          	label: 'Hủy',
		          	onClick: () => false
		        }
	      	]
	    });
	}

	confirmAlertAdminRequest = (id) => {
		let dataAuth = {
			username: process.env.REACT_APP_CLIENT_ID,
			password: process.env.REACT_APP_CLIENT_PASSWD,
			token: process.env.REACT_APP_KEY,
		};
		let params = {id: id};
		let config = {
		  	headers: {
				'Content-Type': 'application/json',
				'Authorization' : this.props.token,
				'dataAgency' : JSON.stringify(dataAuth)
			}
		}

		axios.post( process.env.REACT_APP_API_URL + '/api/admin/alert-admin/confirm', params, config)
		.then( (ref) => {
			console.log(ref.data);
			this.setState({
				isLoading: false,
				error: false,
				messageError: '',
				isNotification: '',
				textNotification: '',
			});
			if ( ref.data.error === 0 ) {
				this.setState({
					isNotification: true,
					textNotification: ref.data.message,
				},
				() => this.getListAlertAdmin()
				)
			} else {
				if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
					this.props.logOut();
				} else {
					this.setState({
						error: true,
						messageError: ref.data.message,
					})
				}
			}
		})
		.catch( (error) => {
			console.log(error);
			this.setState({
				isLoading: false
			});
			this.setState({
				error: true,
				messageError: 'Lấy dữ liệu thất bại',
			})
		})
	}

	listAlertAdminRow = () => {
        if ( this.state.isLoading ) {
            return (
                <tr>
                    <td className="text-center" colSpan={12}>
                        <Spinner animation="grow" variant="primary" />
                        <Spinner animation="grow" variant="secondary" />
                        <Spinner animation="grow" variant="success" />
                        <Spinner animation="grow" variant="danger" />
                        <Spinner animation="grow" variant="warning" />
                        <Spinner animation="grow" variant="info" />
                    </td>
                </tr>
            );
        } else {
            if ( this.state.listAlertAdmin.length ) {
                return (
                    this.state.listAlertAdmin.map( (alert, key) => {
                        return (
                            <ListAlertAdminComponent
	                            key={key}
	                            alert={alert}
	                            actionKey={key}
	                            confirm={ (id) => this.confirmAlertAdmin(id) }
	                            checkedAlertAdmin = { (actionKey) => this.checkedAlertAdmin(actionKey) }
                                checkedAlertAdminShiftKey = { (actionKey, value) => this.checkedAlertAdminShiftKey(actionKey, value) }
                            />
                        )
                    })
                );
            } else {
                return (
                    <tr>
                        <td className="text-center text-danger" colSpan="12">
                            Không có dữ liệu!
                        </td>
                    </tr>
                );
            }
        }
    }

    checkNotification = () => {
		if ( this.state.isNotification ) {
			return (
				<Alert color="success">{ this.state.textNotification } </Alert>
				);
		}
	}

	sort = (order_by) => {
		this.setState(
			{
				rq_table: {
			        ...this.state.rq_table, 
					order_by: order_by, 
					order: this.state.rq_table.order === 'desc' ? 'asc' : 'desc'
			    }
			},
			() => this.getListAlertAdmin()
		)
	}	

	change = (e) => {
		this.setState(
			{
				currentPage: 0,
				rq_table: {
			        ...this.state.rq_table, 
					[e.target.name]: e.target.value,
					page: 0
			    }
			},
			() => this.getListAlertAdmin()
		)
	}

    search = (e) => {
	    this.setState(
	    	{
		    	rq_table: {
			        ...this.state.rq_table, 
					[e.target.name]: e.target.value
			    }
		    }
	    )
    }

    submitSearch = (e) => {
        if(e.key === 'Enter') {
        	this.setState(
				{
					currentPage: 0,
					rq_table: {
				        ...this.state.rq_table,
						page: 0
				    }
				},
				() => this.getListAlertAdmin()
			)
        }
    }

    btnSearch = () => {
        this.setState(
			{
				currentPage: 0,
				rq_table: {
			        ...this.state.rq_table,
					page: 0
			    }
			},
			() => this.getListAlertAdmin()
		)
    }

    paginate = () => {
        if (this.state.totalPage > this.state.perPage) {
            return (
                <PaginateComponent
                    total={this.state.totalPage}
                    perPage={this.state.perPage}
                    currentPage={this.state.currentPage}
                    btnPaginate={ (page) => this.btnPaginate(page) }
                />
            );
        }
    }

    btnPaginate = (page) => {
		this.setState(
			{
				currentPage: page,
				rq_table: {
			        ...this.state.rq_table, 
					page: page
			    }
			},
			() => this.getListAlertAdmin()
		)
    }

    checkAll = (e) => {
        let value = e.target.checked;
        let listAlertAdmin = this.state.listAlertAdmin;
        listAlertAdmin.forEach( email => {
            email.checked = value;
        });
        this.setState({
            checkAll: value,
            listAlertAdmin: listAlertAdmin
        });
        this.checkedAlertAdminIds(listAlertAdmin);
    }


    checkedAlertAdmin  = (actionKey) => {
        let listAlertAdmin = this.state.listAlertAdmin;
        listAlertAdmin[actionKey].checked = !listAlertAdmin[actionKey].checked;
        this.setState({
            listAlertAdmin: listAlertAdmin,
            checkedStart: actionKey
        });
        this.checkedAlertAdminIds(listAlertAdmin);
    }

    checkedAlertAdminShiftKey = (actionKey, value) => {
        if ( this.state.checkedStart !== -1 ) {
            let listAlertAdmin = this.state.listAlertAdmin;
            let n = Math.abs( actionKey - this.state.checkedStart );
            let i = this.state.checkedStart;
            let k = actionKey;
            if ( actionKey < this.state.checkedStart ) {
                i = actionKey;
                k = this.state.checkedStart;
            }
            for (i; i <= n; i++) {
                listAlertAdmin[i].checked = value;
            }
            this.setState({
                listAlertAdmin: listAlertAdmin,
                checkedStart: k
            });
            this.checkedAlertAdminIds(listAlertAdmin);
        } else {
            let listAlertAdmin = this.state.listAlertAdmin;
            listAlertAdmin[actionKey].checked = !listAlertAdmin[actionKey].checked;
            this.setState({
                listAlertAdmin: listAlertAdmin,
                checkedStart: actionKey
            });
            this.checkedAlertAdminIds(listAlertAdmin);
        }
    }

    checkedAlertAdminIds = (listAlertAdmin) => {
    	let checkedAlertAdminIds = [];
    	listAlertAdmin.forEach( alert => {
    		if (alert.checked) {
    			checkedAlertAdminIds.push(alert.id)
    		}
        });
        this.setState({
        	checkedAlertAdminIds: checkedAlertAdminIds
        })
    }

    confirmCheckedAlertAdmin = () => {
    	if (this.state.checkedAlertAdminIds.length) {
    		confirmAlert({
		      	title: '',
		      	message: 'Xác nhận hoàn thành các cảnh bảo đã chọn?',
		      	buttons: [
			        {
			          	label: 'Xác nhận',
			          	onClick: () => { this.confirmCheckedAlertAdminRequest() }
			        },
			        {
			          	label: 'Hủy',
			          	onClick: () => false
			        }
		      	]
		    });
    	} else {
    		confirmAlert({
		      	title: '',
		      	message: 'Bạn chưa chọn mục để xác nhận?',
		      	buttons: [
			        {
			          	label: 'OK',
			          	onClick: () => false
			        }
		      	]
		    });
    	}
    }

    confirmCheckedAlertAdminRequest = () => {

    	let dataAuth = {
			username: process.env.REACT_APP_CLIENT_ID,
			password: process.env.REACT_APP_CLIENT_PASSWD,
			token: process.env.REACT_APP_KEY,
		};
		let params = {ids: this.state.checkedAlertAdminIds}
		let config = {
		  	headers: {
				'Content-Type': 'application/json',
				'Authorization' : this.props.token,
				'dataAgency' : JSON.stringify(dataAuth)
			}
		}

		axios.post( process.env.REACT_APP_API_URL + '/api/admin/alert-admin/multi-confirm', params, config)
		.then( (ref) => {
			// console.log(ref.data);
			this.setState({
				isLoading: false,
				error: false,
				messageError: '',
				isNotification: '',
				textNotification: '',
			});
			if ( ref.data.error === 0 ) {
				this.setState({
					isNotification: true,
					textNotification: ref.data.message,
					checkedAlertAdminIds: [],
				},
				() => this.getListAlertAdmin()
				)
			} else {
				if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
					this.props.logOut();
				} else {
					this.setState({
						error: true,
						messageError: ref.data.message,
					})
				}
			}
		})
		.catch( (error) => {
			console.log(error);
			this.setState({
				isLoading: false
			});
			this.setState({
				error: true,
				messageError: 'Lấy dữ liệu thất bại',
			})
		})
    }

    loadQttChecked = () => {
        let n = 0;
        if ( this.state.listAlertAdmin.length ) {
            this.state.listAlertAdmin.forEach( alert => {
                if ( alert.checked ) {
                    n++;
                }
            })
        }
        return (n);
    }

	render() {
		return (
			<>
                <Breadcrumb title={"Cảnh báo"} page={"Cảnh báo"} icon={<MdWarning className="breadcrumb-icon" />} />

                <Row style={{ marginTop: 20 }}>
					<Col sm={12}>
						{ this.state.error ? (<Alert color="danger"><div className='text-center'>{ this.state.messageError }</div></Alert>) : (<></>)}
						{this.checkNotification()}
					</Col>
				</Row>

                <Card body>
                    <Row>
                    	<Col sm={12}>
							<button
								className={`btn btn-${this.state.checkedAlertAdminIds.length ? 'success' : 'outline-success'} btn-sm mb-3 mx-2 `}
								onClick={ () => this.confirmCheckedAlertAdmin() }
							>
								<MdCheck /> Xác nhận mục chọn
							</button>
						</Col>
						{
	                        this.state.listAlertAdmin.length ? (
	                        	<>
	                        		<Col md={12}>
		                                Hiển thị từ { this.state.from } đến { this.state.to } / Tổng: { this.state.totalPage }
		                            </Col>
		                            <Col md={12} className="text-primary mb-3">
				                        <b>
				                            Đã chọn:
				                            <span className="qtt-checkbox"> { this.loadQttChecked() }</span> / <span className="total-item">{ this.state.listAlertAdmin.length }</span>
				                        </b>
				                    </Col>
	                	 		</>
	                        ) : (
	                        <></>
	                        )
	                    }
                    	<Col sm={12} className="table-responsive">
                    		<Table className="table table-sm table-bordered table-hover rounded text-center">
		                        <thead className="primary">
		                            <tr>
		                            	<th className="text-center" width="5%">
		                            		<input
									          	type="checkbox"
									          	defaultValue={false}
									          	onChange={ this.checkAll }
									        />
		                            	</th>
		                                <th width="10%"
		                                	onClick={ () => this.sort('id') } 
		                                	className={`text-center sorting ${this.state.rq_table.order_by === "id"? 'order_by': ''} 
		                                		${this.state.rq_table.order_by === "id" && this.state.rq_table.order === "desc" ? 'sorting_desc': ''}
		                                		${this.state.rq_table.order_by === "id" && this.state.rq_table.order === "asc" ? 'sorting_asc': ''}
		                            		`}
		                                >
		                                	ID
		                                </th>
		                                <th className={'text-center'} width="25%">Dịch vụ</th>
		                                <th className={'text-center'} width="35%">Lỗi</th>
		                                <th className={'text-center'} width="15%">Thời gian</th>
		                                <th className={'text-center'} width="10%">Action</th>
		                            </tr>
		                        </thead>
		                        <tbody>
		                            { this.listAlertAdminRow() } 
		                        </tbody>
		                    </Table>
		                    <Row>
		                    	{
			                        this.state.listAlertAdmin.length ? (
			                        	<>
			                        		<Col md={12} className="mb-2">
				                                Hiển thị từ { this.state.from } đến { this.state.to } / Tổng: { this.state.totalPage }
				                            </Col>
			                	 		</>
			                        ) : (
			                        <></>
			                        )
			                    }
		                    </Row>
		                    { this.paginate() }
                    	</Col>
                    </Row>
                </Card>
            </>	
		)
	}
}

const mapStateToProps = (state) => {
	return {
		token: state.login.token,
		isNotification: state.adminMain.isNotification,
		textNotification: state.adminMain.textNotification,
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		logOut: () => {
			dispatch(({ type : 'logOut', page: 'AdminAlert' }))
		},
		notification: (item) => {
			dispatch(({ type : 'notification', item }))
		},
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(AlertAdminPage);